// Material-UI
import { Button, Theme, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { EventModalTypes } from "src/components/DialogModal/DialogModalWrapper";
import { useDispatch } from "react-redux";
import { openWindow } from "src/redux/actions/Mosaic.Actions";
import { IconButton } from "src/components/IconButton/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

interface ITimelineActions {
  setActiveEventModal: (activeEventModal: EventModalTypes) => void;
  setTabValue: React.Dispatch<React.SetStateAction<string | boolean>>;
}

const TimelineActionStyles = (theme: Theme): any => ({
  display: "flex",
  padding: "10px",
  flexFlow: "row",
  "& .heading": {
    display: "contents",
  },
  "& .control": {
    display: "inline-flex",
    margin: "5px",
    padding: "5px",
    backgroundColor: theme.custom.forms.inputBack,
    borderRadius: "5px",
    alignItems: "center",
    "& .control_action": {
      fontSize: 12,
      maxWidth: 150,
      margin: "0px 8px",
    },
  },
  "& .control_action_command": {
    display: "flex",
    "& .add_icon": {
      color: theme.palette.primary.main,
    },
  },
});

/**
 * TimelineActions TOOL
 * Tool will display any actions available.
 */
export const TimelineActions = (props: ITimelineActions): JSX.Element => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { setActiveEventModal, setTabValue } = props;

  const swapAircraftEvents = (): void => {
    setActiveEventModal(EventModalTypes.SwapAircraft);
  };

  const openFlightPairingStatusWindow = (): void => {
    dispatch(openWindow("Flight Pairing Status", "FlightPairingStatusWindow", [], {}, "content"));
  };

  const openFlightPairingStatusV2Window = (): void => {
    // v2 of the tool (cached, event-driven status). The original window above stays until v2 is adopted.
    // One window: a second click focuses the open one instead of opening a competing copy.
    dispatch(openWindow("Flight Pairing Status v2", "FlightPairingStatusV2Window", [], {}, "content", true));
  };

  return (
    <Box sx={TimelineActionStyles(theme)}>
      <IconButton style={{ paddingBottom: "4px" }} onClick={() => setTabValue(false)}>
        <VisibilityOffIcon fontSize="small" />
      </IconButton>
      <Button id={"swap_aircraft_events_btn"} variant="outlined" onClick={swapAircraftEvents}>
        {" "}
        Swap Aircraft Events{" "}
      </Button>
      <Button id={"swap_aircraft_events_btn"} variant="outlined" onClick={openFlightPairingStatusWindow}>
        View Flight Pairing Status
      </Button>
      <Button id={"flight_pairing_status_v2_btn"} variant="outlined" onClick={openFlightPairingStatusV2Window}>
        View Flight Pairing Status v2
      </Button>
    </Box>
  );
};
